import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './GoodsAdditionalInfo.less';

export default class GoodsAdditionalInfo extends OfficialPage {
  state = {
    goods_info: [],
    additional_info_obj: {},
    from: ''
  }
  delivery_id_arr = []
  goods_id_arr = []

  constructor(props) {
    super(props);
    document.title = '补充信息';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    if (options.hiddenSub) {
      this.setData({
        hiddenSub: options.hiddenSub
      })
    }
    if (options.from) {
      this.setData({
        from: options.from
      })
    }
    if (options.appId) {
      this.selectedAppId = options.appId
    }
    this.dataInitial()
  }

  dataInitial = () => {
    this.getAppECStoreConfig()
    var goodsInfo = app.getPreviewGoodsInfo(),
      additional_info = app.getGoodsAdditionalInfo(),
      additionalInfoWrited = false
    this.setData({
      goods_info: goodsInfo,
      additional_info_obj: additional_info
    })
    for (var key in additional_info) {
      if (key !== undefined) {
        additionalInfoWrited = true
        break
      }
    }
    if (additionalInfoWrited) {
      return
    }
    for (var i = 0; i <= goodsInfo.length - 1; i++) {
      let id = goodsInfo[i].id || goodsInfo[i].goods_id
      if (this.goods_id_arr.indexOf(id) == -1) {
        this.goods_id_arr.push(id)
        this.delivery_id_arr.push(goodsInfo[i].delivery_id)
      }
    }
    if (this.delivery_id_arr.length) {
      this.getDeliveryInfo()
    }
  }
  getDeliveryInfo = () => {
    var that = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=pc/AppShop/GetDelivery',
      method: 'post',
      data: {
        delivery_ids: this.delivery_id_arr
      },
      success: function (res) {
        var goods_info = that.data.goods_info,
          delivery_arr = res.data,
          additional_info_obj = {}
        for (var i = 0; i <= delivery_arr.length - 1; i++) {
          var goods_id = goods_info[i].id || goods_info[i].goods_id,
            delivery_info = delivery_arr[i].delivery_info
          additional_info_obj[goods_id] = []
          for (var j = 0; j <= delivery_info.length - 1; j++) {
            if (delivery_info[j].is_hidden == 1) {
              // is_hidden = 1 时不隐藏字段
              additional_info_obj[goods_id].push({
                title: delivery_info[j].name,
                type: delivery_info[j].type,
                is_required: delivery_info[j].is_required,
                value: ''
              })
            }
          }
        }
        that.setData({
          additional_info_obj: additional_info_obj
        })
      }
    })
  }
  inputFormControl = e => {
    var goodsId = e.currentTarget.dataset.goodsId,
      additionalIndex = e.currentTarget.dataset.additionalIndex,
      value = e.target.value,
      data = {}
    data[
      'additional_info_obj.' + goodsId + '[' + additionalIndex + '].value'
    ] = value
    this.setData(data)
  }
  uploadImg = e => {
    var that = this,
      goodsId = e.currentTarget.dataset.goodsId,
      additionalIndex = e.currentTarget.dataset.additionalIndex,
      images =
        this.data.additional_info_obj[goodsId][additionalIndex].value || []
    app.chooseImage(function (imageArr) {
      var data = {}
      data[
        'additional_info_obj.' + goodsId + '[' + additionalIndex + '].value'
      ] = images.concat(imageArr)
      that.setData(data)
    }, 9 - images.length)
  }
  deleteImage = e => {
    var dataset = e.currentTarget.dataset,
      goodsId = dataset.goodsId,
      additionalIndex = dataset.additionalIndex,
      imageIndex = dataset.imageIndex,
      images = this.data.additional_info_obj[goodsId][additionalIndex].value,
      data = {}
    images.splice(imageIndex, 1)
    data[
      'additional_info_obj.' + goodsId + '[' + additionalIndex + '].value'
    ] = images
    this.setData(data)
  }
  submitAdditionalInfo = () => {
    var additional_info_obj = this.data.additional_info_obj,
      completeInfo = true
    for (var goodsId in additional_info_obj) {
      if (!completeInfo) {
        break
      }
      if (additional_info_obj[goodsId]) {
        var goods_additional_info = additional_info_obj[goodsId]
        for (var i = 0; i <= goods_additional_info.length - 1; i++) {
          if (
            goods_additional_info[i].is_required == 0 &&
            (!goods_additional_info[i].value ||
              goods_additional_info[i].value.length == 0)
          ) {
            app.showModal({
              content: goods_additional_info[i].title + '不能为空'
            })
            completeInfo = false
            break
          }
        }
      }
    }
    if (!completeInfo) {
      return
    }
    var pages = app.getCurrentPages()
    var prePage = pages[pages.length - 2]
    if (this.selectedAppId) {
      // 多店情况
      prePage.setData({
        [`mulShopsInfo.${this.selectedAppId}.additional_info`]: this.data
          .additional_info_obj,
        [`mulShopsInfo.${this.selectedAppId}.deliverydWrite`]: true
      })
    } else {
      prePage.setData({
        additional_info: this.data.additional_info_obj,
        deliverydWrite: true
      })
    }
    prePage.additional_info = this.data.additional_info_obj
    prePage.hasRequiredSuppInfo = false
    app.turnBack()
  }
  previewImage = e => {
    var dataset = e.currentTarget.dataset,
      goodsId = dataset.goodsId,
      additionalIndex = dataset.additionalIndex,
      imageIndex = dataset.imageIndex,
      urls = this.data.additional_info_obj[goodsId][additionalIndex].value
    app.previewImage({
      current: urls[imageIndex],
      urls: urls
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }

  render() {
    const {
      showGetUserInfo,
      additional_info_obj,
      storeStyle,
      hiddenSub,
      from,
      goods_info
    } = this.state

    return (
      <div className="official-page goods-additional-info">
        <TopNav title="补充信息" />
        {!from && (
          <div className="editor-additional">
            {goods_info.map((goods, index) => {
              return (
                <div key={goods.id}>
                  <div className="additional-box">
                    <div className="goods-detail">
                      <img className="goods-cover" src={goods.cover} />
                      <div className="goods-info">
                        <div className="goods-title">
                          {goods.title || goods.goods_name}
                        </div>
                        {goods.model_value_str && (
                          <div className="goods-model">
                            {goods.model_value_str}
                          </div>
                        )}
                      </div>
                    </div>
                    {additional_info_obj[goods.id || goods.goods_id] && additional_info_obj[goods.id || goods.goods_id].map(
                      (item, additionalIndex) => {
                        return (
                          <div className="additional-list" key={additionalIndex}>
                            {item.type == 'text' && (
                              <div className="additional-text">
                                <span
                                  className={
                                    'additional-name ' +
                                    (item.is_required == 0 ? 'is-required' : '')
                                  }
                                >
                                  {item.title}
                                </span>
                                <div className="additional-info">
                                  <input
                                    type="text"
                                    onChange={this.inputFormControl}
                                    data-goods-id={goods.id || goods.goods_id}
                                    data-additional-index={additionalIndex}
                                    value={item.value}
                                  />
                                </div>
                              </div>
                            )}
                            {item.type == 'mul-text' && (
                              <div className="additional-textarea">
                                <span
                                  className={
                                    'additional-name ' +
                                    (item.is_required == 0 ? 'is-required' : '')
                                  }
                                >
                                  {item.title}
                                </span>
                                <div className="additional-info">
                                  <textarea
                                    maxLength="-1"
                                    onInput={this.inputFormControl}
                                    data-goods-id={goods.id || goods.goods_id}
                                    data-additional-index={additionalIndex}
                                    value={item.value}
                                  ></textarea>
                                </div>
                              </div>
                            )}
                            {item.type == 'picture' && (
                              <div className="additional-picture">
                                <span
                                  className={
                                    'additional-name ' +
                                    (item.is_required == 0 ? 'is-required' : '')
                                  }
                                >
                                  {item.title}
                                </span>
                                <div className="additional-info">
                                  {item.value && item.value.map((imgSrc, imageIndex) => {
                                    return <div className="image-list" key={imageIndex}>
                                      <img src={imgSrc} />
                                      <label
                                        className="delete-image ico-moon icon-closes"
                                        onClick={this.deleteImage}
                                        data-goods-id={
                                          goods.id || goods.goods_id
                                        }
                                        data-additional-index={
                                          additionalIndex
                                        }
                                        data-image-index={imageIndex}
                                      >
                                        -
                                      </label>
                                    </div>
                                  })}
                                  {item.value.length < 9 && (
                                    <div
                                      className="add-images"
                                      onClick={this.uploadImg}
                                      data-goods-id={goods.id || goods.goods_id}
                                      data-additional-index={additionalIndex}
                                    >
                                      <span className="ico-moon icon-goods-add-image"></span>
                                      <div>添加图片</div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      }
                    )}
                  </div>
                </div>
              )
            })}
            <div
              className="additional-sure"
              style={convertLineStyleData('background:' + storeStyle.theme)}
              onClick={this.submitAdditionalInfo}
              hidden={hiddenSub}
            >
              提交
            </div>
          </div>
        )}
        {(from == 'goodsOrderDetail' || from == 'diningOrderDetail') && (
          <div className="show-additional">
            {goods_info.map((goods, index) => {
              return (
                <div key={goods.id}>
                  <div className="additional-box">
                    <div className="goods-detail">
                      <img
                        className="goods-cover"
                        mode="scaleToFill"
                        src={goods.cover}
                      />
                      <div className="goods-info">
                        <div className="goods-title">
                          {goods.title || goods.goods_name}
                        </div>
                        {goods.model_value_str && (
                          <div className="goods-model">
                            {goods.model_value_str}
                          </div>
                        )}
                      </div>
                    </div>
                    {additional_info_obj[goods.id || goods.goods_id] && additional_info_obj[goods.id || goods.goods_id].map(
                      (item, additionalIndex) => {
                        return (
                          <div className="additional-list" key={additionalIndex}>
                            {item.type == 'text' && (
                              <div className="additionals-text">
                                <span
                                  className={
                                    'additional-name ' +
                                    (item.is_required == 0 ? 'is-required' : '')
                                  }
                                >
                                  {item.title}
                                </span>
                                <div className="additional-info">
                                  {item.value}
                                </div>
                              </div>
                            )}
                            {item.type == 'mul-text' && (
                              <div className="additional-textarea">
                                <span
                                  className={
                                    'additional-name ' +
                                    (item.is_required == 0 ? 'is-required' : '')
                                  }
                                >
                                  {item.title}
                                </span>
                                <div className="additional-info">
                                  {item.value}
                                </div>
                              </div>
                            )}
                            {item.type == 'picture' && (
                              <div className="additional-picture">
                                <span
                                  className={
                                    'additional-name ' +
                                    (item.is_required == 0 ? 'is-required' : '')
                                  }
                                >
                                  {item.title}
                                </span>
                                <div className="additional-info">
                                  {item.value.map((imgSrc, imageIndex) => {
                                    return (
                                      <div className="image-list" key={imageIndex}>
                                        <img
                                          src={imgSrc}
                                          onClick={this.previewImage}
                                          data-image-index={imageIndex}
                                          data-additional-index={
                                            additionalIndex
                                          }
                                          data-goods-id={
                                            goods.id || goods.goods_id
                                          }
                                        />
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      }
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-additional-info/GoodsAdditionalInfo.jsx